export default {
  type: 'menu',
  code: '16000000'
}
